import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  Component,
  Input,
  Output,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationErrorService } from 'src/app/core/services/error/validation-error/validation-error.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Represents a select field
 */
export class SelectComponent implements OnInit, OnDestroy {
  @Input() placeholder?: string;
  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() options?: any[];
  @Input() value?: number | string;
  @Input() hasIdAndValue?: boolean = false;
  @Input() isValueString?: boolean = false;
  @Input() disabled: boolean = false;
  @Output() selectionChange = new EventEmitter<string>();
  panelIsOpen: boolean = false;

  private _required: boolean = false;
  private _isSmall = false;
  private subsink = new Subscription();
  errorMessage = '';

  /**
   * @constructor
   */
  constructor(private validationErrorService: ValidationErrorService) {}

  /**
   * on init
   */
  ngOnInit() {
    this.setErrorMessage(this.control);
    const subscription = this.control.statusChanges.subscribe(() => {
      this.setErrorMessage(this.control);
    });
    this.subsink.add(subscription);
  }

  /**
   * clean up subscriptions
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * If this select is required or not
   * @return {boolean}
   */
  @Input()
  get required(): boolean {
    return this._required;
  }

  /**
   * Sets this select as required
   * @param {any} value
   */
  set required(value: any) {
    this._required = coerceBooleanProperty(value);
  }

  /**
   * Sets error message of this input
   * @param {AbstractControl} abstractControl
   */
  setErrorMessage(abstractControl: AbstractControl) {
    this.validationErrorService
      .translateError(abstractControl)
      .then((errorMessage) => {
        this.errorMessage = errorMessage;
      });
  }

  /**
   * Controls icon change after click in select
   */
  handleOpenChange() {
    this.panelIsOpen = !this.panelIsOpen;
  }

  /**
   * Controls icon change after click in select
   */
  changeSelect() {
    this.selectionChange.emit();
  }

  /**
   * Decides if this height is smaller
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._isSmall;
  }

  /**
   * Sets this height as a smaller one by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._isSmall = coerceBooleanProperty(value);
  }
}
